const readFlag = name => !!localStorage.getItem(name);

const writeFlag = (name, value) => value
  ? localStorage.setItem(name, 1)
  : localStorage.removeItem(name);

export default {
  get dialog() {
    return readFlag('ff.dialog');
  },

  get htmlModule() {
    return readFlag('ff.htmlModule');
  },

  get i18n() {
    return readFlag('ff.i18n');
  },

  get logger() {
    return readFlag('ff.logger');
  },

  get inactiveJobApplication() {
    return readFlag('ff.inactiveJobApplication');
  },

  get anonymousProfiles() {
    return readFlag('ff.anonymousProfiles');
  },

  get imports() {
    return true; // deprecated
  },

  get search() {
    return true; // deprecated
  },

  setFlag(name, state) {
    writeFlag(`ff.${name}`, state);
  },

  resetAll() {
    writeFlag('ff.dialog', false);
    writeFlag('ff.htmlModule', false);
    writeFlag('ff.i18n', false);
    writeFlag('ff.logger', false);
    writeFlag('ff.inactiveJobApplication', false);
    writeFlag('ff.anonymousProfiles', false);
  }
};
